import { DeviceTypes } from "../../config/documents/HardwareConfig";
import { PoolDeviceInterface } from "../Interfaces";
import Locale from "../../utils/Locale";
import PoolDevice from "./base";

export default class PoolDeviceFlowRelay extends PoolDevice implements PoolDeviceInterface {
    static minAutoFilterVersion = 6;
    static DeviceType = DeviceTypes.FLOWRELAY;
    // water-sync is probabaly better, but probably need to update icon package
    static Icon = "source-branch-sync";
    static PickerTitle = Locale.gettext("Flow Relay");
}
